import { ReactNode } from 'react'

import { Icon } from '../icon'

export enum StepStatus {
  active = 'active',
  completed = 'completed',
  disabled = 'disabled',
}

export const DefaultStepIcon: { [key in StepStatus]: ReactNode } = {
  [StepStatus.active]: (
    <Icon name="big-dot" size={26} className="text-purple-500" />
  ),
  [StepStatus.completed]: (
    <div className="flex h-[26px] w-[26px] items-center justify-center">
      <Icon name="check" size={16} strokeWidth={2} className="text-black" />
    </div>
  ),
  [StepStatus.disabled]: (
    <Icon name="dot" size={26} className="text-gray-100" />
  ),
}
